import { ApolloClient, ApolloLink, InMemoryCache } from "@apollo/client";
import { HttpLink } from "@apollo/client/link/http";
import UploadHttpLink from "apollo-upload-client/UploadHttpLink.mjs";
import extractFiles from "extract-files/extractFiles.mjs";
import isExtractableFile from "extract-files/isExtractableFile.mjs";

import { config } from "~/config";

export type AuthenticatedFetch = (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>;

export const getClientWithAuthenticatedFetch = (authenticatedFetch: AuthenticatedFetch): ApolloClient => {
  const httpLink = new HttpLink({
    uri: config.graphqlEndpoint,
    fetch: authenticatedFetch,
  });

  const uploadLink = new UploadHttpLink({
    uri: config.cnutGraphqlEndpoint,
    headers: { "Apollo-Require-Preflight": "true" },
    fetch: authenticatedFetch,
  });

  const splitLink = ApolloLink.split(
    (operation) => extractFiles(operation, isExtractableFile).files.size > 0,
    uploadLink,
    httpLink,
  );

  return new ApolloClient({
    link: splitLink,
    cache: new InMemoryCache(),
  });
};
